export default "__VITE_ASSET__DznsDM_D__"